import BaseAPIService from '../base/base-api-service';
import WarrantyClaimModel from 'src/model/warrantyClaim.model';
import env from 'src/shared/env';
import i18n from 'src/translation/i18n';

class DamageClaimService extends BaseAPIService<any> {
  private wpBaseURL: string = env.REACT_APP_BASE_WORDPRESS_URL;
  public endpoint: string = 'wp-json/acf/v3/warrantyClaimField?page=1&per_page=100';
  public claimsubmitted: any;
  constructor() {
    super(WarrantyClaimModel);
  }

  public getdamageClaimNumber() {
    const accountId = localStorage.getItem('activeAccount');
    // console.log(accountId);
    return new Promise((resolve, reject) => {
      const claimNumberEndpoint = `${this.baseURL}accountapp/v1/warranty/claims/number?claimType=damaged&accountId=${accountId}`;

      this.doRequest({
        method: 'get',
        url: claimNumberEndpoint
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public getNewClaimNumber(sendClaimType: any) {
    const accountId = localStorage.getItem('activeAccount');
    // console.log(accountId);
    return new Promise((resolve, reject) => {
      const claimNumberEndpoint = `${this.baseURL}accountapp/v1/warranty/claims/number?claimType=${sendClaimType}&accountId=${accountId}`;

      this.doRequest({
        method: 'get',
        url: claimNumberEndpoint
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  public objToQueryString(obj: any) {
    // console.log(obj);
    const keyValuePairs = [];
    for (let i = 0; i < Object.keys(obj).length; i += 1) {
      keyValuePairs.push(
        `${encodeURIComponent(Object.keys(obj)[i])}=${encodeURIComponent(
          Object.values(obj)[i].toString()
        )}`
      );
    }
    return keyValuePairs.join('&');
  }
  public checkClaimSubmitted(partClaimData: any) {
    return new Promise((resolve, reject) => {
      const iParams: any = {
        originalInvoiceNumber: partClaimData.part[0].invoiceNumber,
        partNumber: partClaimData.part[0].partNumber,
        prevClaimNumber: partClaimData.previousClaimNumber
      };

      const csAPIUrl = `${
        this.baseURL
      }warrantyapp/v1/part-claim/isClaimResubmitted?${this.objToQueryString(
        iParams
      )}`;
      this.doRequest({
        method: 'get',
        url: csAPIUrl
      })
        .then(response => {
          resolve(response);
        })
        .catch((error: any) => {
          // console.log(error);
          reject(error);
        });
    });
  }
  public SubmitdamageClaim(partClaimData: any) {
    // debugger;
    const pStatus = partClaimData.claimResubmit;
    // claimResubmit:'',
    //   previousClaimNumber:'',

    const partClaimEndpoint = `${this.baseURL}warrantyapp/v1/part-claim/damage`;
    return new Promise((resolve, reject) => {
      this.doRequest({
        method: 'post',
        url: partClaimEndpoint,
        data: partClaimData
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public SubmitNewTypesClaim(partClaimData: any) {
    // debugger;
    const pStatus = partClaimData.claimResubmit;
    // claimResubmit:'',
    //   previousClaimNumber:'',

    const partClaimEndpoint = `${this.baseURL}warrantyapp/v1/part-claim`;
    return new Promise((resolve, reject) => {
      this.doRequest({
        method: 'post',
        url: partClaimEndpoint,
        data: partClaimData
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}
const DamageClaimServiceInstance = new DamageClaimService();
Object.freeze(DamageClaimServiceInstance);

export default DamageClaimServiceInstance;
